module.exports = __webpack_public_path__ + "static/media/Vector71.a9d73645.svg";